<div class="stepper">
  <ng-container *ngFor="let step of steps; let i = index">
    <div *ngIf="i > 0" class="stepper-connector" [class.filled]="isConnectorFilled(step)"></div>
    <div class="stepper-dot"
         [class.filled]="isFilled(step)"
         [class.ready]="isReady(step)"
         [class.locked]="!isFilled(step) && !isReady(step)"
         [class.current]="isCurrent(step)"
         [class.clickable]="isClickable(step)"
         [title]="'Step ' + step"
         (click)="onClick(step)"></div>
  </ng-container>
</div>
